import { Component, OnInit } from '@angular/core';
import { LiveUpdateService } from '../shared/live-update.service';
import { Campaign } from '../shared/models/campaign';
import { TabHeadingDirective } from 'ngx-bootstrap';

@Component({
  selector: 'ae-carousel',
  templateUrl: './carousel.component.html',
  styles: []
})
export class CarouselComponent implements OnInit {
public promos: Campaign[] = [];

  constructor(private live: LiveUpdateService) {

  }

  ngOnInit() {
    this.live.campaigns$.subscribe(this.updatePromos.bind(this));
    this.live.getCampaigns();
  }


  public updatePromos(camps: Campaign[]) {
    if (camps && camps.length > 0) {
      this.promos = camps.filter((el) => {
        return el.active === true;
      });

      this.promos.sort((a, b) =>  a.displayNumber - b.displayNumber);
    }
  }
}
